import styled from 'styled-components/macro';

export const ClearFilterWrapper = styled.div`
  cursor: pointer;
`;
